import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import { GET_WIDGET, GET_WIDGETS } from "./actionTypes";

import { setWidget, apiError, setWidgets } from "./actions";

import axios from "axios";

function* getWidgets() {
  try {
    const response = yield call(axios.get, "/user/widgets");
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setWidgets(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getWidget({ payload: { chatId, widgetId } }) {
  try {
    const response = yield call(axios.post, "/widget-data", {
      widgetId: widgetId,
      conversationId: chatId,
    });
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setWidget(chatId, widgetId, response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchGetWidgets() {
  yield takeEvery(GET_WIDGETS, getWidgets);
}

export function* watchWidget() {
  yield takeEvery(GET_WIDGET, getWidget);
}

function* authSaga() {
  yield all([fork(watchGetWidgets), fork(watchWidget)]);
}

export default authSaga;
